import axios from 'axios';

//const API_BASE_URL = 'http://localhost:4000/api';

const API_BASE_URL = "https://api.coresell.ir/api";

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor
api.interceptors.response.use(
  (response) => {
    // Extract data from response if it exists
    if (response.data && response.data.data) {
      return { ...response, data: response.data };
    }
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      const message = error.response?.data?.message || '';
      const requestUrl = String(error.config?.url || '');
      const isLoginRequest = requestUrl.includes('/auth/login');
      // رمز اشتباه همان درخواست ورود است؛ نباید از صفحه لاگین خارج شود
      const isGatewayTokenError = /توکن (دیجی‌کالا|باسلام)/i.test(message);
      const onLoginPage = window.location.hash.startsWith('#/auth/login')
        || window.location.pathname === '/auth/login';
      if (!isGatewayTokenError && !isLoginRequest) {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        if (!onLoginPage) {
          window.location.hash = '#/auth/login';
        }
      }
    }
    return Promise.reject(error);
  }
);

export default api;
